import { useContext } from 'react'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import useWebhook from '@hooks/useWebhook'

import type { WebhookModel } from '@models/types'

const confirmDelete = (
  deleteWebhook: (payload: HandleCallbackActionParams) => Promise<object>,
  deleteFn: () => void,
) => {
  const deleteWebhookPayload = {
    callbacks: {
      action: deleteFn,

    },
    toastText: 'Webhook Deleted',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure? It cannot be recovered.',
      title: 'Delete Webhook?',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        deleteWebhook(deleteWebhookPayload)
      }
    })
}

const WebhookActions = (props: { webhook: Partial<WebhookModel> }) => {
  const { webhook } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      deleteWebhook,
    },
  } = pageContext

  const {
    callbacks: {
      createOrEditWebhook,
      deleteWebhook: deleteFn,
    },
  } = useWebhook(webhook)

  return (
    <Box justifyContent="center" alignItems="center">
      <Link
        greyLink
        onClick={() => createOrEditWebhook()}
        textProps={{ fontSize: 'medium', height: 'fit-content', marginRight: 'medium' }}
      >
        <FontAwesomeIcon icon={faPencil} />
      </Link>

      <Link
        greyLink
        onClick={() => confirmDelete(deleteWebhook, deleteFn)}
        textProps={{ fontSize: 'medium', height: 'fit-content' }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>
    </Box>
  )
}

export default WebhookActions
